import React, { useState, useEffect, useRef } from "react";
import Topbar from "../layouts/Topbar";
import Sidebar from "../layouts/Sidebar";
import Footer from "../layouts/Footer";
import { Outlet, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function Main() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Offcanvas States
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [offcanvasTitle, setOffcanvasTitle] = useState("");
  const [offcanvasContent, setOffcanvasContent] = useState(null);
  const [isMinimized, setIsMinimized] = useState(false);

  const location = useLocation();

  // Reference for dragging
  const offcanvasRef = useRef(null);
  const pos = useRef({ x: 0, y: 0, dx: 0, dy: 0 });
  const dragging = useRef(false);

  // Auto-minimize when page changes
  useEffect(() => {
    if (offcanvasOpen) {
      setIsMinimized(true);
    }
  }, [location.pathname]);

  const handleSidebarToggle = () =>
    setIsSidebarCollapsed((prev) => !prev);

  // GLOBAL open panel
  window.openPanel = (title, content) => {
    setOffcanvasTitle(title);
    setOffcanvasContent(content);
    setOffcanvasOpen(true);
    setIsMinimized(false);

    // Reset default position
    if (offcanvasRef.current) {
      offcanvasRef.current.style.top = "4rem";
      offcanvasRef.current.style.right = "0px";
      offcanvasRef.current.style.left = "";
    }
  };

  // GLOBAL close panel
  window.closePanel = () => {
    setOffcanvasOpen(false);
    setTimeout(() => {
      setOffcanvasContent(null);
      setOffcanvasTitle("");
    }, 300);
  };

  // Minimize toggle
  const toggleMinimize = () => setIsMinimized(!isMinimized);

  // ---------------- DRAG LOGIC ----------------
  const startDrag = (e) => {
    dragging.current = true;

    const panel = offcanvasRef.current;
    pos.current.dx = e.clientX - panel.offsetLeft;
    pos.current.dy = e.clientY - panel.offsetTop;

    document.addEventListener("mousemove", onDrag);
    document.addEventListener("mouseup", stopDrag);
  };

  const onDrag = (e) => {
    if (!dragging.current) return;

    const panel = offcanvasRef.current;
    let newX = e.clientX - pos.current.dx;
    let newY = e.clientY - pos.current.dy;

    // Prevent dragging off-screen
    if (newX < 0) newX = 0;
    if (newY < 0) newY = 0;

    panel.style.left = `${newX}px`;
    panel.style.top = `${newY}px`;
    panel.style.right = "auto"; // Disable fixed right alignment once dragged
  };

  const stopDrag = () => {
    dragging.current = false;
    document.removeEventListener("mousemove", onDrag);
    document.removeEventListener("mouseup", stopDrag);
  };
  // --------------------------------------------------------

  return (
    <div
      id="layout-wrapper"
      className={isSidebarCollapsed ? "sidebar-enable sidebar-collpsed" : ""}
    >
      <Topbar onToggleSidebar={handleSidebarToggle} />
      <Sidebar collapsed={isSidebarCollapsed} />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>

      {/* -------------------- GLOBAL DRAGGABLE RIGHT PANEL -------------------- */}
      <div
        ref={offcanvasRef}
        className={`offcanvas offcanvas-end ${offcanvasOpen ? "show" : ""}`}
        tabIndex="-1"
        style={{
          position: "fixed",
          visibility: offcanvasOpen ? "visible" : "hidden",
          width: isMinimized ? "420px" : "1200px",
          transition: "width 0.25s ease",
          top: "4rem",
          right: "0px",
          height: isMinimized ? "60vh" : "calc(100vh - 7rem)",
          boxShadow: "-3px 0px 12px rgba(0,0,0,0.15)",
          borderRadius: "8px",
          zIndex: 9999,
          cursor: dragging.current ? "grabbing" : "default",
        }}
      >
        <div
          className="offcanvas-header"
          style={{ cursor: "grab" }}
          onMouseDown={startDrag}
        >
          <h5 className="offcanvas-title">{offcanvasTitle}</h5>

          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={toggleMinimize}
            >
              {isMinimized ? "Expand" : "Minimize"}
            </button>

            <button className="btn-close" onClick={() => window.closePanel()} />
          </div>
        </div>

        <div className="offcanvas-body" style={{ overflowY: "auto" }}>
          {offcanvasContent}
        </div>
      </div>
      {/* ---------------------------------------------------------------------- */}
    </div>
  );
}

export default Main;

/* import React from "react";
import { useState } from "react";
import Topbar from "../layouts/Topbar";
import Sidebar from "../layouts/Sidebar";
import Footer from "../layouts/Footer";
import { Outlet } from "react-router-dom";

function Main() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  return (
    <div
      id="layout-wrapper"
      className={isSidebarCollapsed ? "sidebar-enable sidebar-collpsed" : ""}
    >
      <Topbar onToggleSidebar={handleSidebarToggle} />
      <Sidebar collapsed={isSidebarCollapsed} />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
export default Main; */